import BaseState from "@state/BaseState";
import GameStatesEnum from "@/states/GameStatesEnum";
import { Signals } from "@/Imports";
import Facade from "@/Facade";

export default class SpinStartState extends BaseState {
  begin() {
    this.model.scatters = false;
    if (Facade.model.isAuto) {
      let enableUIDelayT = this.getEnableUIDelay();
      if (enableUIDelayT > 0) {
        setTimeout(() => {
          Signals.startSpin.dispatch();
          this.end();
        }, enableUIDelayT);
      } else {
        Signals.startSpin.dispatch();
        this.end();
      }
    } else {
      //Signals.autospinCountChanged.dispatch (0)
      Signals.startSpin.dispatch();
      this.end();
    }
  }
  getEnableUIDelay = () => {
    return !Facade.model.lastSpinTime
      ? 0
      : Math.max(
          0,
          Facade.model.minIntervalSpin -
            (new Date().getTime() - Facade.model.lastSpinTime.getTime())
        );
  };
  end = () => {
    this.stateMachine.setState(GameStatesEnum.GET_SPIN_RESPONSE);
  };
}
